// extracted by mini-css-extract-plugin
export default {"expressCheckoutSection":"zw-z","expressButtonContainerWithPayPal":"Aw-z","expressButton":"Bw-z","or":"Cw-z"};